<template>
  <div class="log-filter-box mb-3" data-test="log-filter-box">
    <form
      class="w-100"
      @submit.prevent="$emit('apply')"
      @keydown.enter.prevent="$emit('apply')"
    >
      <slot />

      <div class="form-row mt-4">
        <div class="col-12 d-flex justify-content-end">
          <button
            class="btn btn-secondary px-4 mr-2"
            type="button"
            @click="$emit('clear')"
          >
            <i class="fal fa-times mr-1" />
            {{ trans("general.clearSearch") }}
          </button>
          <button
            class="btn btn-primary px-4"
            type="submit"
            data-test="log-filter-search"
          >
            <i class="far fa-search mr-1" />
            {{ trans("general.search") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  emits: ["apply", "clear"],
};
</script>

<style scoped>
.log-filter-box {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.5rem;
  padding: 1rem 1rem 1.25rem 1rem;
}
</style>
